<template>
  <div>
    <jd-dialog
      title="补发奖品"
      :visible.sync="isShowSendPrize"
      @confirm="confirmSendPrize"
      @close="closeDialog"
    >
      <div>
        <jd-tip>
          <div>
            1、该功能仅针对当前活动发放失败和奖品失的客户进行补发奖品，如选择的用户奖品已发放或还未到达发放时间将不进行发放奖品，且导入补发名单时，用户未满足奖品失效和发放失败也不发放
          </div>
          <div>
            2、如发放的奖品中计划状态为【已结束】（例：京豆计划）也会发放失败，需重新选择计划进行发放，其中优惠券、专享价、令牌、红包、爱奇艺会员、PLUS会员替换后可能会出现与配置的奖品不同，因此发放记录会变
            为补发的奖品名称；
          </div>
          <div>
            3、发放的京豆、积分奖品数量会根据原本配置的数量进行发放，其余奖品根据所选的发放数量进行发放；（实物奖品不进行补发）
          </div>
        </jd-tip>
        <div class="mt16">
          <div class="send-box mt16">
            <div class="label-style">选择补发用户：</div>
            <el-radio-group
              v-model="ruleForm.compensationType"
              @change="handleCompensationType"
            >
              <el-radio :label="1">全部已失效奖品补发</el-radio>
              <el-radio :label="2">全部发放失败奖品补发</el-radio>
              <el-radio :label="3">根据查询条件补发</el-radio>
              <el-radio :label="4">导入补发</el-radio>
            </el-radio-group>
          </div>
          <div class="send-box mt16">
            <div class="label-style">发放奖品数：</div>
            <span v-if="ruleForm.compensationType != 4" v-loading="countLoading"
              >{{ sendCount }}条</span
            >
            <div class="upload-box" v-else>
              <!-- <div class="flexc-cen-x"> -->
              <el-upload
                class="upload-demo"
                accept=".xlsx,.xls"
                action="https://jsonplaceholder.typicode.com/posts/"
                :on-remove="removeFile"
                :file-list="fileList"
                :before-upload="beforeUpload"
                :http-request="httpUpload"
              >
                <jd-button type="blueLine">点击上传文件</jd-button>
              </el-upload>
              <div class="tem-box">
                <jd-button
                  class="ml12"
                  type="blueText"
                  @click="handleDownloadSend"
                  >下载模板</jd-button
                >
              </div>
              <!-- </div> -->
            </div>
          </div>
          <div class="send-box mt16" v-loading="tableLoading">
            <div class="label-style">已结束奖品计划：</div>
            <div class="table-box">
              <jd-table
                :tableData="endPrizePlanList"
                :tableInfo="tableInfo"
                v-if="endPrizePlanList.length > 0"
              >
                <template #planStatusSlot="{ row }">
                  {{ row.status == 1 ? "未结束" : "已结束" }}
                </template>
                <template #replacePlanNameSlot="{ row, rowIndex }">
                  <div class="btn-box">
                    <span class="mr4" v-if="row.prizeList.length > 0">{{
                      row.prizeList[0].title
                    }}</span>
                    <!-- 优惠券 -->
                    <jd-button
                      v-if="row.prizeType == 1"
                      :loading="countLoading"
                      :disabled="
                        sendCount == 0 && ruleForm.compensationType != 4
                      "
                      @click="handleClickCoupon(row, rowIndex)"
                      >选择优惠券（{{ row.prizeList.length }}/1）</jd-button
                    >
                    <!-- 京豆 -->
                    <jd-button
                      v-else-if="row.prizeType == 2"
                      :loading="countLoading"
                      :disabled="
                        sendCount == 0 && ruleForm.compensationType != 4
                      "
                      @click="handleClickCoupon(row, rowIndex)"
                      >选择京豆（{{ row.prizeList.length }}/1）</jd-button
                    >
                    <!-- 京东E卡 -->
                    <jd-button
                      v-else-if="row.prizeType == 5"
                      :loading="countLoading"
                      :disabled="
                        sendCount == 0 && ruleForm.compensationType != 4
                      "
                      @click="handleClickCoupon(row, rowIndex)"
                      >选择京东E卡（{{ row.prizeList.length }}/1）</jd-button
                    >
                    <!-- 爱奇艺会员年卡 -->
                    <jd-button
                      v-else-if="row.prizeType == 6"
                      :loading="countLoading"
                      :disabled="
                        sendCount == 0 && ruleForm.compensationType != 4
                      "
                      @click="handleClickCoupon(row, rowIndex)"
                      >选择爱奇艺会员（{{ row.prizeList.length }}/1）</jd-button
                    >
                    <!-- PLUS会员年卡 -->
                    <jd-button
                      v-else-if="row.prizeType == 7"
                      :loading="countLoading"
                      :disabled="
                        sendCount == 0 && ruleForm.compensationType != 4
                      "
                      @click="handleClickCoupon(row, rowIndex)"
                      >选择PLUS会员（{{ row.prizeList.length }}/1）</jd-button
                    >
                    <!-- 现金红包 -->
                    <jd-button
                      v-else-if="row.prizeType == 8"
                      :loading="countLoading"
                      :disabled="
                        sendCount == 0 && ruleForm.compensationType != 4
                      "
                      @click="handleClickCoupon(row, rowIndex)"
                      >选择现金红包（{{ row.prizeList.length }}/1）</jd-button
                    >
                    <!-- 礼品卡 -->
                    <jd-button
                      v-else-if="row.prizeType == 10"
                      :loading="countLoading"
                      :disabled="
                        sendCount == 0 && ruleForm.compensationType != 4
                      "
                      @click="handleClickCoupon(row, rowIndex)"
                      >选择礼品卡（{{ row.prizeList.length }}/1）</jd-button
                    >
                    <!-- 专享价 -->
                    <jd-button
                      v-else-if="row.prizeType == 12"
                      :loading="countLoading"
                      :disabled="
                        sendCount == 0 && ruleForm.compensationType != 4
                      "
                      @click="handleClickCoupon(row, rowIndex)"
                      >选择专享价（{{ row.prizeList.length }}/1）</jd-button
                    >
                    <!-- 令牌 -->
                    <jd-button
                      v-else-if="row.prizeType == 13"
                      :loading="countLoading"
                      :disabled="
                        sendCount == 0 && ruleForm.compensationType != 4
                      "
                      @click="handleClickCoupon(row, rowIndex)"
                      >选择令牌（{{ row.prizeList.length }}/1）</jd-button
                    >
                  </div>
                </template>
              </jd-table>
              <span v-else>无</span>
            </div>
          </div>
        </div>
      </div>
    </jd-dialog>
    <!-- 补发结果弹窗 -->
    <jd-dialog
      title="补发结果"
      :visible.sync="isShowResult"
      @confirm="confirmResultDialog"
      @close="closeResultDialog"
    >
      <div class="dialog-content">
        <div class="mb16">
          <span>发放成功：{{ sendTotalObj.successNum }}</span>
          <span>发放失败：{{ sendTotalObj.failNum }}</span>
        </div>
        <jd-table :tableData="taskData" :tableInfo="taskInfo">
          <template #statusSlot="{ row }">
            <span v-if="row.status == 0">待执行</span>
            <span v-if="row.status == 1">执行中</span>
            <span v-if="row.status == 2">执行结束</span>
          </template>
          <template #action="{ row }">
            <jd-button type="blueText" @click="handleClickDetail(row)"
              >查看详情</jd-button
            >
          </template>
        </jd-table>
        <div
          class="loadding-box"
          v-if="isShowLoading"
          v-loading="isShowLoading"
          element-loading-text="补发结果生成中，请稍候..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0.5)"
        ></div>
      </div>
    </jd-dialog>
    <jd-dialog
      title="补发详情"
      :visible.sync="isShowDetail"
      :isShowSure="false"
      :isShowCancel="false"
      @close="isShowDetail = false"
    >
      <div class="dialog-content">
        <jd-table
          :tableData="resultData"
          :tableInfo="resultInfo"
          :pageInfo="{
            pageNum: pageInfo.current,
            pageSize: pageInfo.size,
            total: resultTotal,
          }"
          @handlePage="handlePageResult"
        >
          <template #statusSlot="{ row }">
            <span v-if="row.status == 0">失败</span>
            <span v-if="row.status == 1">成功</span>
          </template>
          <template #prizeTypeSlot="{ row }">
            <span>{{ getPrizeTypeName(row.prizeType) }}</span>
          </template>
        </jd-table>
        <div
          class="loadding-box"
          v-if="isShowLoading"
          v-loading="isShowLoading"
          element-loading-text="补发结果生成中，请稍候..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255,255,255,0.5)"
        ></div>
      </div>
    </jd-dialog>
    <!-- 选择奖品 -->
    <selectProduct
      ref="selectProductRef"
      v-if="isShowPrizeDialog"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :isShowCoupon="currentType == 1"
      :isShowJingdou="currentType == 2"
      :isShowEK="currentType == 5"
      :isShowIQY="currentType == 6"
      :isShowPLUS="currentType == 7"
      :isShowHongBao="currentType == 8"
      :isShowGiftCard="currentType == 10"
      :showExclusive="currentType == 12"
      :showNewToken="currentType == 13"
      :defaultSelect="defaultSelect"
      :isShowThing="false"
      :hideShopPoints="true"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      @choose-shop="getPrizeData"
    >
    </selectProduct>
  </div>
</template>
<script>
import selectProduct from "../select_product_componentization.vue";
import {
  reissuePrizeCount,
  reissuePrizeCreate,
  reissuePrizeResult,
  reissuePrizeRecordCount,
  reissuePrizeTaskList,
  uploadFileByType,
  getOrderRankCompensationCount,
  getTrialActivityRebuyCompensationCount
} from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import { prizeSum } from "@/api/jhk/paradiseAndTaskCommonController";
export default {
  components: {
    selectProduct,
  },
  props: {
    isShowSendPrize: {
      type: Boolean,
      default: false,
    },
    valueRow: {
      type: Object,
      default: () => ({}),
    },
    searchCond: {
      type: Object,
      default: null,
    },
    otherSaearch: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      timer: null,
      countLoading: false,
      detailRow: {},
      noEndPrizePlanList: [],
      endPrizePlanList: [],
      prizePlanList: [],
      sendTotalObj: {
        sendNum: 0,
        successNum: 0,
        failNum: 0,
      },
      sendCount: 0,
      uuid: "",
      pageInfo: {
        current: 1,
        size: 10,
      },
      resultTotal: 0,
      isShowDetail: false,
      isShowResult: false,
      resultLoading: false,
      taskData: [],
      resultData: [],
      isShowResult: false,
      uploadStatus: -1,
      fileList: [],
      defaultSelect: "first",
      itemArr: [],
      currentObj: {},
      currentIndex: 0,
      echoDate: {},
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      isShowPrizeDialog: false,
      ruleForm: {
        compensationType: 1,
        fileUrl: "",
        fileName: "",
      },
      tableLoading: false,
      tableInfo: [
        {
          label: "奖品名称",
          prop: "title",
        },
        {
          label: "计划状态",
          prop: "planStatus",
          slot: "planStatusSlot",
        },
        {
          label: "替换奖品计划",
          prop: "replacePlanName",
          slot: "replacePlanNameSlot",
        },
      ],
    };
  },
  computed: {
    taskInfo() {
      return [
        {
          label: "任务名称",
          prop: "taskName",
        },
        {
          label: "任务状态",
          prop: "status",
          slot: "statusSlot",
        },
        {
          label: "失败原因",
          prop: "failReason",
          type: "scalable",
        },
        {
          label: "操作",
          prop: "action",
          slot: "action",
        },
      ];
    },
    resultInfo() {
      return [
        {
          label: `用户${this.isGray ? "xid" : "pin"}`,
          prop: this.isGray ? "xid" : "pin",
          type: "scalable",
        },
        {
          label: "中奖ID",
          prop: "recordId",
        },
        {
          label: "奖品名称",
          prop: "prizeName",
        },
        {
          label: "奖品类型",
          prop: "prizeType",
          slot: "prizeTypeSlot",
        },
        {
          label: "发放状态",
          prop: "status",
          slot: "statusSlot",
        },
        {
          label: "失败原因",
          prop: "failReason",
          type: "scalable",
        },
      ];
    },
    isGray() {
      return this.$store.state.loginUserInfo.isGray;
    },
  },
  watch: {},
  mounted() {
    console.log(this.valueRow,'yyyy');
    this.getList();
    this.getCountData();
  },
  methods: {
    getResultData() {
      this.resultLoading = true;
      reissuePrizeResult({
        uuid: this.detailRow.uuid,
        prizeType: this.detailRow.prizeType,
        current: this.pageInfo.current,
        size: this.pageInfo.size,
      }).then((res) => {
        this.resultLoading = false;
        if (res.code == 1) {
          this.resultData = res.data.records || [];
          this.resultTotal = res.data.total || 0;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleClickDetail(row) {
      this.detailRow = row;
      this.isShowDetail = true;
      this.getResultData();
    },
    handleCompensationType(val) {
      if (val != 4) {
        this.getCountData();
      }
    },
    handleDownloadSend() {
      let url =
        "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/%E8%A1%A5%E5%8F%91%E5%A5%96%E5%93%81%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
    },
    // 获取结束的计划奖品
    getList() {
      this.tableLoading = true;
      prizeSum({ activityId: this.valueRow.id }).then((res) => {
        this.tableLoading = false;
        this.prizePlanList = res.data || [];
        if (this.prizePlanList.length > 0) {
          this.endPrizePlanList = this.prizePlanList.filter(
            (item) => item.status == 0
          );
          this.noEndPrizePlanList = this.prizePlanList.filter(
            (item) => item.status == 1
          );
          this.endPrizePlanList = this.endPrizePlanList.map((item) => {
            this.$set(item, "prizeList", []);
            return item;
          });
        }
      });
    },
    //补偿发放奖品结果汇总查询
    async getReissuePrizeRecordCount() {
      try {
        const res = await reissuePrizeRecordCount({
          uuid: this.uuid,
        });
        if (res.code == 1) {
          this.sendTotalObj = res.data;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {}
    },
    async getCountData() {
      try {
        this.countLoading = true;
        let params = {
          activityId: this.valueRow.id,
          compensationType: this.ruleForm.compensationType,
        };
        if (this.ruleForm.compensationType == 3) {
          params = {
            ...params,
            ...this.searchCond,
          };
        }
        if (this.otherSaearch) {
          params.winType = this.otherSaearch.winType;
        }
        let reqFn;
        if(this.valueRow.activityType == 52){
          reqFn = getTrialActivityRebuyCompensationCount
        } else if(this.valueRow.activityType == 36){
          reqFn = getOrderRankCompensationCount
        } else {
          reqFn = reissuePrizeCount
        }
        const res = await reqFn(params);
        this.countLoading = false;
        if (res.code == 1) {
          this.sendCount = res.data;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.countLoading = false;
      }
    },
    handlePageResult({ pageNum, pageSize }) {
      this.pageInfo.current = pageNum;
      this.pageInfo.size = pageSize;
      this.getResultData();
    },
    closeResultDialog() {
      clearTimeout(this.timer);
      this.isShowResult = false;
    },
    confirmResultDialog() {
      clearTimeout(this.timer);
      this.isShowResult = false;
    },
    beforeUpload(file) {
      if (file.size / 1024 / 1024 > 50) {
        this.$message.warning("文件不得超过50M");
        return false;
      }
      if (
        file.type !=
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type != "application/vnd.ms-excel" &&
        file.type != "text/csv"
      ) {
        this.$message.warning("请上传正确格式的文件");
        return false;
      }
    },
    removeFile(file, fileList) {
      this.ruleForm.fileUrl = "";
      this.ruleForm.fileName = "";
      this.uploadStatus = -1;
      this.fileList = [];
    },
    httpUpload({ file }) {
      this.removeFile();
      let formData = new FormData();
      formData.append("file", file);
      this.uploadStatus = 0;
      uploadFileByType(5, formData).then((res) => {
        if (res.code == 1) {
          this.uploadStatus = 1;
          this.ruleForm.fileUrl = res.data.fileUrl;
          this.ruleForm.fileName = file.name;
          this.fileList = [{ name: file.name, url: res.data.fileUrl }];
          this.$message({
            message: "文件上传成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.message || "文件上传失败",
            type: "error",
          });
          this.uploadStatus = 2;
        }
      });
    },
    handleRemove(file, fileList) {
      this.uploadStatus = -1;
      this.fileList = [];
      this.ruleForm.fileUrl = "";
      this.ruleForm.fileName = "";
    },
    async confirmSendPrize() {
      let planList = [];
      if (this.ruleForm.compensationType != 4 && this.sendCount == 0) {
        this.$message({
          message: "暂无奖品可补发",
          type: "warning",
        });
        return;
      }
      if (this.ruleForm.compensationType == 4) {
        if (!this.ruleForm.fileUrl) {
          this.$message({
            message: "请先上传文件",
            type: "warning",
          });
          return;
        }
      }
      if (this.endPrizePlanList.length > 0) {
        const prizeObj = this.endPrizePlanList.find((item) => {
          return item.prizeList.length == 0;
        });
        if (prizeObj) {
          this.$message({
            message: `【${prizeObj.title}】奖品未选择替换发放的奖品；`,
            type: "warning",
          });
          return;
        }
        this.endPrizePlanList.forEach((item) => {
          if (item.prizeList.length > 0) {
            const obj = {
              prizeType: item.prizeList[0].prizeType,
              assetsId: item.prizeList[0].assetsId,
              prizeName: item.prizeList[0].title,
              assetsName: item.prizeList[0].title,
              prizeId: item.prizeId,
            };
            planList.push(obj);
          }
        });
      }
      // 过滤非实物奖品和非随单发奖品
      const list = this.noEndPrizePlanList.filter(
        (item) => item.prizeType != 3 && item.prizeType != 14
      );
      if (list.length > 0) {
        list.forEach((item) => {
          const obj = {
            prizeType: item.prizeType,
            assetsId: item.assetsId,
            prizeName: item.title,
            assetsName: item.title,
            prizeId: item.prizeId,
          };
          planList.push(obj);
        });
      }
      if (planList.length == 0) {
        this.$message({
          message: "暂无奖品可补发",
          type: "warning",
        });
        return;
      } else {
        try {
          const params = {
            activityId: this.valueRow.id,
            planList: planList,
            ...this.ruleForm,
          };
          if (this.ruleForm.compensationType != 3&&this.otherSaearch) {
            params.cond = JSON.stringify(this.otherSaearch);
          } else {
            params.cond =
              this.ruleForm.compensationType == 3 && this.searchCond
                ? JSON.stringify(this.searchCond)
                : "";
          }
          const res = await reissuePrizeCreate(params);
          if (res.code == 1 && res.data) {
            this.$message({
              message: "补发奖品任务创建成功",
              type: "success",
            });
            this.isShowLoading = true;
            this.pageInfo.current = 1;
            this.pageInfo.size = 10;
            this.uuid = res.data;
            this.isShowResult = true;
            this.$emit("createFn");
            const maxPollingTime = 10 * 60 * 1000;
            const pollingInterval = 2500;
            let pollingTime = 0;
            while (pollingTime < maxPollingTime) {
              await new Promise(
                (resolve) => (this.timer = setTimeout(resolve, pollingInterval))
              );
              pollingTime += pollingInterval;

              const result = await reissuePrizeTaskList({
                uuid: this.uuid,
              });
              if (result.data.compensationStatus == 0) {
                continue;
              } else if (result.data.compensationStatus == 1) {
                this.taskData = result.data.detailList;
                this.getReissuePrizeRecordCount();
                this.isShowLoading = false;
                break;
              } else {
                this.$message.warning("网络繁忙稍后再试，并不扣除次数");
                break;
              }
            }
            this.getList();
          } else {
            throw new Error(res.message || "补发奖品任务创建失败");
          }
        } catch (error) {
          this.$message({
            message: error.message || "补发奖品任务创建失败",
            type: "error",
          });
        } finally {
          this.isShowLoading = false;
        }
      }
    },
    async pollReissuePrizeCreate(planList) {
      const maxRetries = 10;
      const interval = 2000;
      for (let i = 0; i < maxRetries; i++) {
        const res = await reissuePrizeCreate({
          activityId: this.valueRow.id,
          planList: planList,
          cond:
            this.ruleForm.compensationType == 3 && this.searchCond
              ? JSON.stringify(this.searchCond)
              : "",
          ...this.ruleForm,
        });
        if (res.code == 1 && res.data) {
          return res.data;
        }
        if (res.code != 1) {
          throw new Error(res.message || "补发奖品任务创建失败");
        }
        await new Promise((resolve) => setTimeout(resolve, interval));
      }
      return "";
    },
    getPrizeData(row, prizeType) {
      this.currentObj = this.getPrizeCommon(row, prizeType);
      this.$set(this.endPrizePlanList[this.currentIndex], "prizeList", [
        this.currentObj,
      ]);
      this.isShowPrizeDialog = false;
    },
    getPrizeCommon(data, prizeType) {
      console.log(data, "data");
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: "",
        title: "",
        percentage: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price =
        prizeType == 13 && data.discount == "" ? "" : Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime
          ? data.isFollowActivityEndTime
          : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.shouldCollectExtraData = data.shouldCollectExtraData;
        prizeObj.extraQuestion = data.extraQuestion;
        prizeObj.addressFillLimit = data.addressFillLimit;
        prizeObj.commitAddressLimit = data.commitAddressLimit;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 12) {
        prizeObj.reducePrice = data.reducePrice;
      }
      if (prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(prizeObj, prizeType, data);
      }
      return prizeObj;
    },
    handleClickCoupon(row, index) {
      this.currentIndex = index;
      this.currentType = row.prizeType;
      this.echoDate =
        this.endPrizePlanList[this.currentIndex].prizeList.length > 0
          ? this.endPrizePlanList[this.currentIndex].prizeList[0]
          : {};
      const tabNames = {
        2: "second",
        5: "fird",
        6: "six",
        7: "sev",
        8: "eig",
        10: "nine",
        12: "eleven",
        13: "twelve",
      };
      this.defaultSelect = tabNames[this.currentType];
      this.itemArr = this.endPrizePlanList[this.currentIndex].prizeList;
      this.isShowPrizeDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProductRef.openDialog();
      });
    },
    closeDialog() {
      this.uploadStatus = -1;
      this.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.send-box {
  width: 100%;
  display: flex;
  .label-style {
    width: 120px;
    text-align: right;
    flex-shrink: 0;
  }
  .table-box {
    flex: 1;
  }
  .upload-box {
    position: relative;
    .tem-box {
      position: absolute;
      top: 8px;
      left: 115px;
    }
  }
}
.dialog-content {
  position: relative;
  .loadding-box {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.5);
    z-index: 999;
  }
}
.btn-box {
  display: flex;
  align-items: center;
}
</style>
